var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.env !== 'PRODUCTION')?_c('div',{staticClass:"ribbon"},[_c('div',[_c('div',[_vm._v(_vm._s(_vm.env))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }